
import { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface CompanyOwnerRouteProps {
  children: ReactNode;
}

const CompanyOwnerRoute = ({ children }: CompanyOwnerRouteProps) => {
  const [isCompanyOwner, setIsCompanyOwner] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkCompanyOwner = async () => {
      try {
        const { data, error } = await supabase.rpc('is_company_owner');
        if (error) throw error;
        setIsCompanyOwner(data);
      } catch (error) {
        console.error('Error checking company owner status:', error);
        setIsCompanyOwner(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkCompanyOwner();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-brand-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-primary"></div>
      </div>
    );
  }

  if (!isCompanyOwner) {
    return <Navigate to="/memorials" replace />;
  }

  return <>{children}</>;
};

export default CompanyOwnerRoute;
